import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import { usePrimitiveText } from "@/v2-ui/text/offline"

export type SpinnerProps = ComponentProps<"div"> & {
  shown?: boolean
  theme?: "light" | "dark"
  displaySize?: "md" | "sm" | "xs"
}

function Spinner(props: SpinnerProps) {
  const { getText } = usePrimitiveText()
  const {
    className,
    shown = true,
    theme = "dark",
    displaySize = "md",
    children = getText("UI_Primitive_Spinner_Loading").Name,
    ...divProps
  } = props

  if (!shown) return null

  const d = `spinner-${displaySize}`
  const t = theme ? `spinner-${theme}` : null

  return (
    <div className={cn("spinner", t, d, className)} {...divProps}>
      <div className="spinner-indicator" />
      {children}
    </div>
  )
}

export default Spinner
